import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
var _excluded = ["locale", "region"],
  _excluded2 = ["locale", "region"],
  _excluded3 = ["locale", "region"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import QS from 'qs';
import Base from './base';
import { UserItem } from '../models';
import { getReqConfig, parsePagination } from '../utils/admin';

/**
 * `Service` The new construction service for ACC Admin
 *
 * Refer to https://autodesk.slack.com/archives/C01RSGGP35Y/p1632150002037700
 * Migration plan at https://wiki.autodesk.com/pages/viewpage.action?spaceKey=SCFICOE&title=FAQ+Guide%3A+Construction+Admin+APIs
 */
var Admin = /*#__PURE__*/function (_Base) {
  /**
   * Create the project service instance.
   *
   * @param sdk - the SDK instance
   */
  function Admin(sdk) {
    _classCallCheck(this, Admin);
    return _callSuper(this, Admin, [sdk]);
  }

  /**
   * Static getter of the class name
   *
   * @returns The detail property name used by SDK instance.
   */
  _inherits(Admin, _Base);
  return _createClass(Admin, [{
    key: "getProjectUsers",
    value: (
    /**
     * Get project users from construction api
     * https://platform.stoplight.autodesk.com/docs/hq-api-server/35b2c4e584406-projects-project-id-users
     *
     * @param projectId -  the project id.
     * @param options - the query parameter options contains offset limit.
     * @param config - Configurable object to overwrite request parameters.
     *
     * @returns a promise that resolve with user list and pagination info.
     */
    function () {
      var _getProjectUsers = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(projectId, options, config) {
        var _ref, _ref$locale, locale, _ref$region, region, rest, query, path, response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _ref = options || {}, _ref$locale = _ref.locale, locale = _ref$locale === void 0 ? this.Config.locale : _ref$locale, _ref$region = _ref.region, region = _ref$region === void 0 ? this.Config.region : _ref$region, rest = _objectWithoutProperties(_ref, _excluded);
              query = QS.stringify(_extends({
                limit: 200,
                offset: 0,
                fields: ['name', 'email', 'autodeskId', 'analyticsId', 'imageUrl', 'companyId', 'companyName', 'roles', 'accessLevels', 'status', 'products']
              }, rest), {
                addQueryPrefix: true,
                encodeValuesOnly: true,
                arrayFormat: 'comma'
              });
              path = "/projects/".concat(projectId, "/users").concat(query);
              _context.next = 5;
              return this.HttpService.accAdminV1.get(path, getReqConfig({
                locale: locale,
                region: region,
                config: config
              }));
            case 5:
              response = _context.sent;
              return _context.abrupt("return", {
                users: response.data.results.map(UserItem.parseAdmin),
                pagination: parsePagination(response.data.pagination)
              });
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getProjectUsers(_x, _x2, _x3) {
        return _getProjectUsers.apply(this, arguments);
      }
      return getProjectUsers;
    }()
    /**
     * Get project user from construction api
     * https://platform.stoplight.autodesk.com/docs/hq-api-server/3600d54ac6068-projects-project-id-users-user-id
     *
     * @param projectId -  the project id.
     * @param userId - the user id or user oxygen id.
     * @param options - the query parameter options.
     * @param config - Configurable object to overwrite request parameters.
     *
     * @returns a promise that resolve with user list and pagination info.
     */
    )
  }, {
    key: "getProjectUser",
    value: (function () {
      var _getProjectUser = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(projectId, userId, options, config) {
        var _ref2, _ref2$locale, locale, _ref2$region, region, rest, query, path, response;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _ref2 = options || {}, _ref2$locale = _ref2.locale, locale = _ref2$locale === void 0 ? this.Config.locale : _ref2$locale, _ref2$region = _ref2.region, region = _ref2$region === void 0 ? this.Config.region : _ref2$region, rest = _objectWithoutProperties(_ref2, _excluded2);
              query = QS.stringify(_extends({
                fields: ['name', 'email', 'autodeskId', 'imageUrl', 'companyId', 'roles', 'accessLevels', 'status', 'products']
              }, rest), {
                addQueryPrefix: true,
                encodeValuesOnly: true,
                arrayFormat: 'comma'
              });
              path = "/projects/".concat(projectId, "/users/").concat(userId).concat(query);
              _context2.next = 5;
              return this.HttpService.accAdminV1.get(path, getReqConfig({
                locale: locale,
                region: region,
                config: config
              }));
            case 5:
              response = _context2.sent;
              return _context2.abrupt("return", UserItem.parseAdmin(response.data));
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getProjectUser(_x4, _x5, _x6, _x7) {
        return _getProjectUser.apply(this, arguments);
      }
      return getProjectUser;
    }()
    /**
     * get project info from construction admin
     * https://platform.stoplight.autodesk.com/docs/hq-api-server/522cf3da0aa86-projects-project-id
     *
     * @param projectId - the project id
     * @param options - with shape of \{ locale, region \}
     * @param config - Configurable object to overwrite request parameters
     * @returns a promise with project information
     */
    )
  }, {
    key: "getProject",
    value: (function () {
      var _getProject = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(projectId, options, config) {
        var _ref3, _ref3$locale, locale, _ref3$region, region, rest, query, response;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _ref3 = options || {}, _ref3$locale = _ref3.locale, locale = _ref3$locale === void 0 ? this.Config.locale : _ref3$locale, _ref3$region = _ref3.region, region = _ref3$region === void 0 ? this.Config.region : _ref3$region, rest = _objectWithoutProperties(_ref3, _excluded3);
              query = QS.stringify(rest, {
                addQueryPrefix: true,
                arrayFormat: 'comma'
              });
              _context3.next = 4;
              return this.HttpService.accAdminV1.get("/projects/".concat(projectId).concat(query), getReqConfig({
                locale: locale,
                region: region,
                config: config
              }));
            case 4:
              response = _context3.sent;
              return _context3.abrupt("return", response.data || {});
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getProject(_x8, _x9, _x10) {
        return _getProject.apply(this, arguments);
      }
      return getProject;
    }())
  }], [{
    key: "getName",
    value: function getName() {
      return 'Admin';
    }
  }]);
}(Base);
export default Admin;